import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
  color: #fff;
  background: #002478;
  font-size: 1em;
  margin: 1.5em;
  padding: 0.25em 1em;
  border: 2px solid #002478;
  border-radius: 3px;
  height: 40px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #003399;
    border-color: #003399;
  }

  &:active {
    background: #001a66;
    border-color: #001a66;
  }
`;

function Btn({ children, ...props }) {
  return (
    <StyledButton {...props}>
      {children}
    </StyledButton>
  );
}

export default Btn; 